import i18n from 'modules/core/lib/i18n'

import Trip from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/mileage/Trip'

import RoundTripField from '../../../Blocks/mileage/RoundTrip/RoundTripField'
import { CustomizationProps } from '../../../withCustomizationFields'
import { PermissionsProps } from '../../../withFieldPermissions'
import FormBlock from '../../FormBlock'

interface Props extends PermissionsProps, CustomizationProps {
  setIsCalculatingDistance?: (loading: boolean) => void
}

const TripInformation = (props: Props) => {
  return (
    <FormBlock
      title={i18n.t('expenses_v2.forms.new_form.blocks.trip_information')}
      subtitle={i18n.t('expenses_v2.forms.new_form.blocks.trip_information_subtitle')}
    >
      <Trip {...props} />
      <RoundTripField {...props} />
    </FormBlock>
  )
}
export default TripInformation
